import { useState } from 'react';

import {
  useDocumentEventListener,
  WAREHOUSE_TASK_COUNT_UPDATED_EVENT,
  type WarehouseTaskCountUpdatedEventDetail,
} from '@shared/hooks';

import { useConfig } from './use_config';

export const useWarehouseTaskCount = () => {
  const config = useConfig();
  const [count, setCount] = useState(config?.user?.warehouse_task_count ?? 0);

  useDocumentEventListener<WarehouseTaskCountUpdatedEventDetail>(WAREHOUSE_TASK_COUNT_UPDATED_EVENT, (event) => {
    setCount(event.count);
  });

  return count;
};
